import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function MentionsLegalesPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">
          <ArrowLeft size={16} /> Retour à l'accueil
        </Link>

        <h1 className="legal-title">Mentions légales</h1>
        <p className="legal-updated">Dernière mise à jour : mars 2026</p>

        <section className="legal-section">
          <h2>Éditeur du site</h2>
          <p>
            Le site <strong>LoL Arena</strong> est édité à titre personnel par son créateur,
            dans le cadre d'un projet de plateforme communautaire de tournois League of Legends.
          </p>
          <p>
            Contact : <a href="mailto:contact@lol-arena.fr">contact@lol-arena.fr</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>Hébergement</h2>
          <p>
            Le site est hébergé par <strong>Hostinger</strong> (UAB Hostinger, 61 Lordou Vironos Street,
            6023 Larnaca, Chypre). Pour toute question relative à l'hébergement :{' '}
            <a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer">
              www.hostinger.fr
            </a>
          </p>
        </section>

        <section className="legal-section">
          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble des contenus présents sur LoL Arena (textes, graphismes, logo, structure) est
            protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation
            expresse est interdite.
          </p>
          <p>
            League of Legends est une marque déposée de <strong>Riot Games, Inc.</strong> LoL Arena
            n'est pas affilié, sponsorisé ni approuvé par Riot Games. Les données de jeu sont
            récupérées via l'API officielle Riot Games conformément à leurs{' '}
            <a
              href="https://developer.riotgames.com/policies/general"
              target="_blank"
              rel="noopener noreferrer"
            >
              conditions d'utilisation de l'API
            </a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>Limitation de responsabilité</h2>
          <p>
            LoL Arena s'efforce de maintenir des informations à jour et exactes. Cependant, l'éditeur
            ne saurait être tenu responsable des erreurs, omissions ou des résultats obtenus par
            un mauvais usage des informations disponibles sur le site.
          </p>
          <p>
            L'accès au site peut être suspendu temporairement sans préavis pour des raisons de
            maintenance ou de force majeure.
          </p>
        </section>

        <section className="legal-section">
          <h2>Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige,
            les tribunaux français seront compétents.
          </p>
        </section>
      </div>
    </div>
  );
}
